interface IProfile {
    elevation_low: number;
    elevation_high: number;
    distance: number;
    average_grade: number;
    maximum_grade: number;
    climb_category: number;
}

const climbCategories = ['nc', '4', '3', '2', '1', 'hc'];

class ProfileAnalyzer {
    public calcProfile(segment: IProfile) {
        let profile = 'unknown';
        const diff = (segment.elevation_low && segment.elevation_high) ? segment.elevation_high - segment.elevation_low : 0;
        const avg = segment.distance && segment.distance > 0 && Math.abs(diff) > 0 ? diff / segment.distance : 0;
        if (segment.average_grade !== null && segment.maximum_grade !== null) {
            if ((Math.abs(segment.average_grade) <= 1) && Math.abs(avg) <= 0.01) {
                profile = 'flat';
            } else if (Math.abs(segment.average_grade) <= 2) {
                profile = 'traverse';
            } else if (segment.average_grade < 0) {
                profile = segment.average_grade < -8.0 ? 'steep_downhill' : 'downhill';
            } else if (segment.average_grade > 0) {
                const cc = segment.climb_category < climbCategories.length ? climbCategories[segment.climb_category] : 'nc';
                profile = cc === 'nc' ? 'uphill' : `climb-${cc}`;
            }
        }
        return profile;
    }

    public calcElevationDelta(segment: IProfile) {
        return segment.average_grade < 0 ? segment.elevation_low - segment.elevation_high :
            segment.elevation_high - segment.elevation_low;
    }
}

const profiler = new ProfileAnalyzer();

export default profiler;
